import React from 'react';
import { CLOSE_CAF_METHOD } from '../../../config/caf';

type Props = {
  handleCloseCaf: (source: string) => void;
}

const CloseModal = (props: Props): JSX.Element => {
  const { handleCloseCaf } = props;

  return (
      <div className="caf-modal__close">
        <svg
          data-testid='close-caf-button'
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="-3 -3 30 30"
          fill="none"
          onClick={(): void => handleCloseCaf(CLOSE_CAF_METHOD.CROSS)}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM10.4632 9.25105C10.1285 8.91632 9.58579 8.91632 9.25105 9.25105C8.91632 9.58579 8.91632 10.1285 9.25105 10.4632L10.8673 12.0795L9.25108 13.6957C8.91635 14.0305 8.91635 14.5732 9.25108 14.9079C9.58582 15.2426 10.1285 15.2426 10.4633 14.9079L12.0795 13.2917L13.6957 14.9079C14.0305 15.2426 14.5732 15.2426 14.9079 14.9079C15.2426 14.5732 15.2426 14.0305 14.9079 13.6957L13.2917 12.0795L14.9079 10.4632C15.2427 10.1285 15.2427 9.58579 14.9079 9.25105C14.5732 8.91632 14.0305 8.91632 13.6958 9.25105L12.0795 10.8673L10.4632 9.25105Z"
            fill="black"
          />
        </svg>
      </div>
  );
};

export default CloseModal;
